import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-99bd079a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tooltip"
};
const _hoisted_2 = ["innerHTML"];
import { sanitize } from 'dompurify';
import { marked } from 'marked';
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppIconTooltip',
  props: {
    buttonText: {},
    text: {},
    textAlign: {
      default: 'start'
    },
    size: {}
  },
  setup(__props) {
    const event = ref(null);
    const popoverOpen = ref(false);
    function openPopover(e) {
      event.value = e;
      popoverOpen.value = true;
    }
    return (_ctx, _cache) => {
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      const _component_ion_popover = _resolveComponent("ion-popover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_ion_button, {
        onClick: _cache[0] || (_cache[0] = $event => openPopover($event)),
        fill: "clear",
        color: "secondary"
      }, {
        default: _withCtx(() => {
          var _ctx$size;
          return [_ctx.buttonText ? (_openBlock(), _createBlock(_component_ion_label, {
            key: 0
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.buttonText), 1)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_ion_icon, {
            name: "help-circle-outline",
            slot: _ctx.buttonText ? 'end' : 'icon-only',
            size: (_ctx$size = _ctx.size) !== null && _ctx$size !== void 0 ? _ctx$size : 'medium'
          }, null, 8, ["slot", "size"])];
        }),
        _: 1
      }), _createVNode(_component_ion_popover, {
        "is-open": popoverOpen.value,
        event: event.value,
        "show-backdrop": false,
        onDidDismiss: _cache[1] || (_cache[1] = $event => popoverOpen.value = false),
        translucent: "",
        "dismiss-on-select": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(`ion-padding-horizontal ion-text-${_ctx.textAlign}`),
          innerHTML: _unref(sanitize)(_unref(marked)(_ctx.text))
        }, null, 10, _hoisted_2)]),
        _: 1
      }, 8, ["is-open", "event"])]);
    };
  }
});